/**
 * @flow
 * @relayHash a2c718ceedff8b5e860436500ddad88a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type productPage_product$ref = any;
export type srcProductQueryVariables = {|
  slug: string
|};
export type srcProductQueryResponse = {|
  +product: ?{|
    +$fragmentRefs: productPage_product$ref
  |}
|};
export type srcProductQuery = {|
  variables: srcProductQueryVariables,
  response: srcProductQueryResponse,
|};
*/


/*
query srcProductQuery(
  $slug: String!
) {
  product(slug: $slug) {
    ...productPage_product
  }
}

fragment productPage_product on Product {
  slug
  name
  variant
  summary
  description
  releaseDate
  shippingFromDate
  discountInfo
  nominationsUntil
  nominationsLink
  nominationsColor
  picture
  shopifyProduct
  shopifyDigitalProduct
  productLabel
  digitalProductLabel
  shopifyBundle
  shopifyBundleLabel
  seo {
    title
    description
  }
  social {
    twitter {
      type
      title
      image
      handle
      description
    }
    generic {
      title
      image
      description
    }
  }
  city {
    slug
    name
    color
    articles(first: 3) {
      slug
      title
      caption
      readingTime
      picture
      author {
        firstname
        lastname
      }
    }
  }
  shipping
  pictures
  content {
    title
    icon
  }
  preview
  quotes {
    quote
    author
    organisation
    link
  }
  sponsors {
    logo
    link
  }
  communityPartners {
    logo
    link
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "logo",
    "args": null,
    "storageKey": null
  },
  v8
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcProductQuery",
  "id": null,
  "text": "query srcProductQuery(\n  $slug: String!\n) {\n  product(slug: $slug) {\n    ...productPage_product\n  }\n}\n\nfragment productPage_product on Product {\n  slug\n  name\n  variant\n  summary\n  description\n  releaseDate\n  shippingFromDate\n  discountInfo\n  nominationsUntil\n  nominationsLink\n  nominationsColor\n  picture\n  shopifyProduct\n  shopifyDigitalProduct\n  productLabel\n  digitalProductLabel\n  shopifyBundle\n  shopifyBundleLabel\n  seo {\n    title\n    description\n  }\n  social {\n    twitter {\n      type\n      title\n      image\n      handle\n      description\n    }\n    generic {\n      title\n      image\n      description\n    }\n  }\n  city {\n    slug\n    name\n    color\n    articles(first: 3) {\n      slug\n      title\n      caption\n      readingTime\n      picture\n      author {\n        firstname\n        lastname\n      }\n    }\n  }\n  shipping\n  pictures\n  content {\n    title\n    icon\n  }\n  preview\n  quotes {\n    quote\n    author\n    organisation\n    link\n  }\n  sponsors {\n    logo\n    link\n  }\n  communityPartners {\n    logo\n    link\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcProductQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "product",
        "storageKey": null,
        "args": v1,
        "concreteType": "Product",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "productPage_product",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcProductQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "product",
        "storageKey": null,
        "args": v1,
        "concreteType": "Product",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "variant",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "summary",
            "args": null,
            "storageKey": null
          },
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "releaseDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shippingFromDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "discountInfo",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "nominationsUntil",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "nominationsLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "nominationsColor",
            "args": null,
            "storageKey": null
          },
          v5,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shopifyProduct",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shopifyDigitalProduct",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "productLabel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "digitalProductLabel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shopifyBundle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shopifyBundleLabel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v6,
              v4
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "type",
                    "args": null,
                    "storageKey": null
                  },
                  v6,
                  v7,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v4
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v6,
                  v7,
                  v4
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "city",
            "storageKey": null,
            "args": null,
            "concreteType": "City",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "color",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": "articles(first:3)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3,
                    "type": "Int"
                  }
                ],
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v2,
                  v6,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "caption",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "readingTime",
                    "args": null,
                    "storageKey": null
                  },
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "author",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Author",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstname",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastname",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shipping",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pictures",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "content",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductContent",
            "plural": true,
            "selections": [
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "icon",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "preview",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "quotes",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductQuote",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quote",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "author",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "organisation",
                "args": null,
                "storageKey": null
              },
              v8
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "sponsors",
            "storageKey": null,
            "args": null,
            "concreteType": "Partner",
            "plural": true,
            "selections": v9
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "communityPartners",
            "storageKey": null,
            "args": null,
            "concreteType": "Partner",
            "plural": true,
            "selections": v9
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5c77f7269d3af370a9794a6e6875000e';
module.exports = node;
